import { createContext, useContext } from "react";

/**
 * Provides a pre-bound `onCellClick` function to all descendant cells.
 * The function already has widget-level metadata baked in from the `Widget` component.
 * Cells only need to supply item-level data (title, url, row, column, etc.).
 */
const WidgetClickContext = createContext(null);

export const WidgetClickProvider = WidgetClickContext.Provider;

/**
 * Consumes the nearest `WidgetClickProvider`.
 * @returns {{ onCellClick: (params: { action?: string, item?: object }) => void } | null}
 */
export const useWidgetClick = () => useContext(WidgetClickContext);
